import { Modal, Button, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faX } from '@fortawesome/pro-solid-svg-icons'
import { ExitConfirmationModalProps } from '../types'

const { Title, Paragraph } = Typography

export const ExitConfirmationModal = ({
  open,
  onCancel,
  onConfirm
}: ExitConfirmationModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={600}
      closeIcon={<FontAwesomeIcon icon={faX} />}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Space direction="horizontal" size="middle">
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#ff4d4f',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <FontAwesomeIcon icon={faX} style={{ color: 'white', fontSize: '20px' }} />
          </div>
          <Title level={4} style={{ margin: 0 }}>Exit Budget Builder?</Title>
        </Space>

        <Paragraph style={{ margin: 0, fontSize: '16px' }}>
          If you leave now, your work will be saved in the budget worksheet, but you won't be able to return to the budget builder. To make changes later, you'll need to edit the worksheet directly.
        </Paragraph>

        <Space style={{ width: '100%', justifyContent: 'flex-end' }} size="middle">
          <Button size="large" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            type="primary"
            size="large"
            onClick={onConfirm}
            style={{ backgroundColor: '#ff6b4a', borderColor: '#ff6b4a' }}
          >
            Exit Budget Builder
          </Button>
        </Space>
      </Space>
    </Modal>
  )
}
